<template>
  <div>
    <b-table
        hover
        striped
        tbody-tr-class="cursor-pointer"
        :items="items"
        :fields="fields"
        show-empty
        empty-text="Нет данных"
        @row-clicked="$emit('row-clicked', $event)"
    ></b-table>
  </div>
</template>

<script>
export default {
  name: 'AppTable',
  props: {
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
}
</script>
